import type { User } from "firebase/auth";
import { defineStore } from "pinia";
import { ref, computed } from "vue";

export const useAuthStore = defineStore("authStore", () => {
	const user = ref<User | null>(null);
	const isAuthReady = ref(false);
	const isLoading = ref(true);

	const isAuthenticated = computed(() => user.value !== null);

	const setUser = (firebaseUser: User) => {
		user.value = firebaseUser;
	};

	const clearUser = () => {
		user.value = null;
	};

	const setLoading = (loading: boolean) => {
		isLoading.value = loading;
	};

	const markAuthReady = () => {
		isAuthReady.value = true;
	};

	const resetAuthReady = () => {
		isAuthReady.value = false;
	};

	return {
		user,
		isAuthReady,
		isLoading,
		isAuthenticated,
		setUser,
		clearUser,
		setLoading,
		markAuthReady,
		resetAuthReady,
	};
});
